import { render, staticRenderFns } from "./addFeed.vue?vue&type=template&id=31a8ee3d&scoped=true"
import script from "./addFeed.vue?vue&type=script&lang=js"
export * from "./addFeed.vue?vue&type=script&lang=js"
import style0 from "./addFeed.vue?vue&type=style&index=0&id=31a8ee3d&prod&lang=less"
import style1 from "./addFeed.vue?vue&type=style&index=1&id=31a8ee3d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a8ee3d",
  null
  
)

export default component.exports